(() => {
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-collection-load-more]');
    if (!button) return;

    event.preventDefault();
    if (button.classList.contains('loading')) return;

    button.classList.add('loading');
    button.setAttribute('aria-disabled', 'true');
    button.querySelector('.loading__spinner')?.classList.remove('hidden');

    try {
      const response = await fetch(button.href, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });
      if (!response.ok) throw new Error(`Request failed with status ${response.status}`);

      const documentFromResponse = new DOMParser().parseFromString(
        await response.text(),
        'text/html',
      );
      const currentGrid = document.getElementById('product-grid');
      const nextGrid = documentFromResponse.getElementById('product-grid');
      if (!currentGrid || !nextGrid) throw new Error('Unable to find the next product page.');

      const fragment = document.createDocumentFragment();
      [...nextGrid.children].forEach((item) => {
        item.classList.add('scroll-trigger--cancel');
        fragment.append(item);
      });
      currentGrid.append(fragment);

      const countIndicator = document.querySelector('[data-collection-shown-count]');
      const shownCount = countIndicator?.querySelector('[data-shown-products]');
      if (shownCount) {
        shownCount.textContent = String(currentGrid.querySelectorAll(':scope > .grid__item').length);
      }

      const nextButton = documentFromResponse.querySelector('[data-collection-load-more]');
      if (nextButton) {
        button.href = nextButton.href;
        button.classList.remove('loading');
        button.removeAttribute('aria-disabled');
        button.querySelector('.loading__spinner')?.classList.add('hidden');
      } else {
        button.closest('[data-collection-load-more-wrap]')?.remove();
      }

      document.dispatchEvent(new CustomEvent('collection:products-appended'));
    } catch (error) {
      console.error('Unable to load more products:', error);
      button.classList.remove('loading');
      button.removeAttribute('aria-disabled');
      button.querySelector('.loading__spinner')?.classList.add('hidden');
    }
  });
})();
